import { FontSize } from './fontSize';

export * from './fontSize';

export default FontSize;
